import React, { useRef, useContext, useMemo } from 'react'
import styled from 'styled-components'

import { LayoutContext } from '../../contexts'
import { useAnnouncementClickedTracking } from '../../hooks/tracking'
import { SiteLink } from '../shared/SiteLink'

const AnnouncementSingle = ({
  announcement,
  announcementBgColor,
  announcementTextColor,
}) => {
  const { node_locale, currency } = useContext(LayoutContext)
  const containerSingle = useRef()
  const isLink = useMemo(() => Boolean(announcement?.target), [announcement])

  return (
    <Container ref={containerSingle}>
      {isLink ? (
        <AnnouncementDiv
          announcementBgColor={announcementBgColor}
          announcementTextColor={announcementTextColor}
        >
          <AnnouncementLink
            to={announcement?.target?.slug}
            extension={announcement.linkExtension}
            onClick={() => {
              useAnnouncementClickedTracking({
                currency: currency?.code,
                locale: node_locale,
                label: announcement.title,
                position: 1,
                destination: `/${node_locale}/${announcement.target.slug}/`,
              })
            }}
            state={{
              referrer:
                typeof window !== 'undefined' && window.location.pathname,
            }}
          >
            <p>{announcement.title}</p>
          </AnnouncementLink>
        </AnnouncementDiv>
      ) : (
        <AnnouncementDiv
          announcementBgColor={announcementBgColor}
          announcementTextColor={announcementTextColor}
        >
          <p>{announcement}</p>
        </AnnouncementDiv>
      )}
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  overflow: hidden;
  height: ${(props) => props.theme.announcementHeight.mobile};

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: ${(props) => props.theme.announcementHeight.desktop};
  }
`

const AnnouncementLink = styled(SiteLink)`
  display: flex;
  align-items: center;
  color: ${({ textColor, theme }) =>
    textColor ? textColor : theme.colors.lightBlack};
  transition: color 0.2s;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    margin: 0 1.5vw;

    &:hover {
      opacity: 0.7;
      transition: color 0.2s;
      svg {
        fill: ${(props) => props.theme.colors.blue};
        ${({ textColor }) =>
          textColor &&
          css`
            fill: ${textColor};
          `}
      }
      path {
        transition: stroke 0.3s;
        /* stroke: ${(props) => props.theme.colors.blue}; */
      }
    }
  }
`
const AnnouncementDiv = styled.div`
  display: inline-flex;
  position: absolute;
  background-color: ${(props) => props.announcementBgColor};
  justify-content: center;
  align-items: center;
  height: ${(props) => props.theme.announcementHeight.mobile};
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: ${(props) => props.theme.announcementHeight.desktop};
  }

  p {
    font-size: ${(props) => props.theme.fontSize.m23};
    padding: ${(props) => props.theme.space.marginMobile / 4}vw 0;
    color: ${(props) => props.announcementTextColor};

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      font-size: ${(props) => props.theme.fontSize.d12};
      padding: ${(props) => props.theme.space.marginDesktop / 3}vw 0;
    }
  }
`

export default AnnouncementSingle
